<div class="service-type-mapping-container">
  <!-- Default Configuration Section -->
  <div class="default-config-section mb-4">
    <h6 class="section-title mb-2">Default Service Type Configuration</h6>
    <p class="text-muted small mb-3">
      {{ helperText() }}
    </p>
    <app-type-subtype-item-row
      [organizationId]="organizationId()"
      [boardId]="boardId()"
      [config]="defaultConfig()"
      (configChanged)="onDefaultConfigChanged($event)"
    ></app-type-subtype-item-row>
  </div>

  <!-- Source Mappings Section -->
  <div class="source-mappings-section">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <div>
        <h6 class="section-title mb-0">Custom Source Mappings</h6>
        <small class="text-muted">Optional</small>
      </div>
      <button
        kendoButton
        fillMode="outline"
        size="small"
        (click)="openAddDialog()"
      >
        <kendo-svgicon [icon]="plusIcon"></kendo-svgicon>
        Add Source Mapping
      </button>
    </div>

    @if (sourceMappings().length > 0) {
      <div class="mapping-table">
        <!-- Table Header -->
        <div class="mapping-header d-flex align-items-center py-2 px-3 bg-light border-bottom">
          <div class="col-source">Ticket Source</div>
          <div class="col-type flex-fill">Type / Sub-Type</div>
          <div class="col-item">Item</div>
          <div class="col-actions text-end">Actions</div>
        </div>

        <!-- Table Rows -->
        @for (mapping of sourceMappings(); track mapping.sourceValue) {
          <div class="mapping-row d-flex align-items-center py-2 px-3 border-bottom">
            <div class="col-source">
              <span class="source-badge">{{ mapping.sourceValue }}</span>
            </div>
            <div class="col-type flex-fill">
              <span [class.text-muted]="!formatTypeDisplay(mapping.config)">
                {{ formatTypeDisplay(mapping.config) || '—' }}
              </span>
            </div>
            <div class="col-item">
              <span [class.text-muted]="!formatItemDisplay(mapping.config)">
                {{ formatItemDisplay(mapping.config) || '—' }}
              </span>
            </div>
            <div class="col-actions text-end">
              <button
                kendoButton
                fillMode="flat"
                size="small"
                [svgIcon]="pencilIcon"
                (click)="openEditDialog(mapping)"
                title="Edit"
              ></button>
              <button
                kendoButton
                fillMode="flat"
                size="small"
                themeColor="error"
                [svgIcon]="trashIcon"
                (click)="openDeleteDialog(mapping)"
                title="Delete"
              ></button>
            </div>
          </div>
        }
      </div>
    } @else {
      <div class="empty-state text-muted text-center py-4 border rounded">
        <p class="mb-1">No custom source mappings configured.</p>
        <small>All tickets will use the default configuration above.</small>
      </div>
    }
  </div>
</div>

<!-- Add/Edit Source Mapping Dialog -->
@if (isDialogOpen()) {
  <app-source-mapping-dialog
    [organizationId]="organizationId()"
    [boardId]="boardId()"
    [existingMapping]="editingMapping()"
    [usedSources]="usedSources()"
    (mappingSaved)="onMappingSaved($event)"
    (dialogClosed)="closeDialog()"
  ></app-source-mapping-dialog>
}

<!-- Delete Confirmation Dialog -->
@if (isDeleteDialogOpen()) {
  <kendo-dialog
    title="Confirm Delete"
    (close)="closeDeleteDialog()"
    [minWidth]="400"
    [width]="450"
  >
    <div class="dialog-content py-2">
      <p>Are you sure you want to remove this source mapping?</p>
      @if (deletingMapping()) {
        <div class="mapping-details p-3 bg-light rounded">
          <strong>Source:</strong> {{ deletingMapping()?.sourceValue }}<br />
          <strong>Type / Sub-Type:</strong> {{ formatTypeDisplay(deletingMapping()!.config) || '—' }}<br />
          <strong>Item:</strong> {{ formatItemDisplay(deletingMapping()!.config) || '—' }}
        </div>
      }
    </div>
    <kendo-dialog-actions>
      <button kendoButton (click)="closeDeleteDialog()">Cancel</button>
      <button kendoButton themeColor="error" (click)="confirmDelete()">Delete</button>
    </kendo-dialog-actions>
  </kendo-dialog>
}
